import { matchRoutes, useLocation } from "react-router";
import { auth, global, guest } from "../../App/routes";

let allRoutes = [
  ...Object.values(auth),
  ...Object.values(guest),
  ...Object.values(global),
];

allRoutes.forEach((route) => {
  if (route.pages) {
    route.pages
      .filter((page) => !page.isIndex)
      .forEach((page) => {
        allRoutes.push({ ...page, path: `${route.link}/${page.link}` });
      });
  }
});

const useCurrentRoute = () => {
  const location = useLocation();

  const route = matchRoutes(
    allRoutes.map((route) => ({ ...route, path: route.link })),
    location.pathname
  );

  if (route?.length) {
    return route[0].route;
  }

  return false;
};

export default useCurrentRoute;
